<div class="ca-numeric-stepper-wrapper">
    @if (title()) {
        <label class="ca-stepper-label">{{ title() }}</label>
    }
    <div class="ca-numeric-stepper" [class.ca-stepper-disabled]="disabled()">
        <div class="ca-stepper-item ca-stepper-item-decrement" (click)="step(-1)">
            <ca-icon icon="big-minus" class="ca-icon-s-16-p-0-f-16"></ca-icon>
        </div>
        <input
            class="ca-stepper-item-value"
            type="number"
            [value]="value()"
            [step]="numericStep()"
            [min]="numericMin()"
            [max]="numericMax()"
            [disabled]="disabled()"
            (input)="onInputChange($event)"
        />
        <div class="ca-stepper-item ca-stepper-item-increment" (click)="step(1)">
            <ca-icon icon="big-plus" class="ca-icon-s-16-p-0-f-16"></ca-icon>
        </div>
    </div>
    <ng-content select="[stepper-error]"></ng-content>
</div>
